import Options from '../lib/options.js'
import ca from './ca'
import enUS from './en-us'
import es from './es'

export default new Options({
  'ca': ca,
  'en-us': enUS,
  'es': es
})
